<script setup lang="ts">
defineOptions({
	name: 'PhonesNumberIcon',
})

interface Props {
	class?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50 w-6 h-6',
})
</script>

<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 25 25"
		:class="props.class"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M5.25 14.25V14.25C4.145 14.25 3.25 13.355 3.25 12.25V12.25C3.25 11.145 4.145 10.25 5.25 10.25V10.25C6.355 10.25 7.25 11.145 7.25 12.25V12.25C7.25 13.355 6.355 14.25 5.25 14.25Z"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.25 14.25V14.25C11.145 14.25 10.25 13.355 10.25 12.25V12.25C10.25 11.145 11.145 10.25 12.25 10.25V10.25C13.355 10.25 14.25 11.145 14.25 12.25V12.25C14.25 13.355 13.355 14.25 12.25 14.25Z"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M19.25 14.25V14.25C18.145 14.25 17.25 13.355 17.25 12.25V12.25C17.25 11.145 18.145 10.25 19.25 10.25V10.25C20.355 10.25 21.25 11.145 21.25 12.25V12.25C21.25 13.355 20.355 14.25 19.25 14.25Z"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M5.25 21.25V21.25C4.145 21.25 3.25 20.355 3.25 19.25V19.25C3.25 18.145 4.145 17.25 5.25 17.25V17.25C6.355 17.25 7.25 18.145 7.25 19.25V19.25C7.25 20.355 6.355 21.25 5.25 21.25Z"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.25 21.25V21.25C11.145 21.25 10.25 20.355 10.25 19.25V19.25C10.25 18.145 11.145 17.25 12.25 17.25V17.25C13.355 17.25 14.25 18.145 14.25 19.25V19.25C14.25 20.355 13.355 21.25 12.25 21.25Z"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M19.25 21.25V21.25C18.145 21.25 17.25 20.355 17.25 19.25V19.25C17.25 18.145 18.145 17.25 19.25 17.25V17.25C20.355 17.25 21.25 18.145 21.25 19.25V19.25C21.25 20.355 20.355 21.25 19.25 21.25Z"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M5.25 7.25V7.25C4.145 7.25 3.25 6.355 3.25 5.25V5.25C3.25 4.145 4.145 3.25 5.25 3.25V3.25C6.355 3.25 7.25 4.145 7.25 5.25V5.25C7.25 6.355 6.355 7.25 5.25 7.25Z"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.25 7.25V7.25C11.145 7.25 10.25 6.355 10.25 5.25V5.25C10.25 4.145 11.145 3.25 12.25 3.25V3.25C13.355 3.25 14.25 4.145 14.25 5.25V5.25C14.25 6.355 13.355 7.25 12.25 7.25Z"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M19.25 7.25V7.25C18.145 7.25 17.25 6.355 17.25 5.25V5.25C17.25 4.145 18.145 3.25 19.25 3.25V3.25C20.355 3.25 21.25 4.145 21.25 5.25V5.25C21.25 6.355 20.355 7.25 19.25 7.25Z"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
